import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { environment } from 'src/app/environments';

@Component({
  selector: 'app-view-social-profile',
  templateUrl: './view-social-profile.component.html',
  styleUrls: ['./view-social-profile.component.css']
})
export class ViewSocialProfileComponent implements OnInit {

  id : any = false
  isLoading : boolean = false
  path : any = environment.ASSETS_URL
  card : any = false

  constructor(
    private dataService : DataService,
    private route : ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.dataService.setTitle('Social Profile | Cards')
    this.route.params.subscribe(
      (params) => {
        this.id = params['id']
        this.getCard();
      }
    )
  }

  getCard() {

    this.isLoading = true

    this.dataService.__post('/social-profile', {id: this.id})
    .subscribe(
      (success) => {
        this.isLoading = false
        this.card = success
        console.log(this.card)
      },
      (error) => {
        this.isLoading = false
        this.dataService.showAlert('error', 'Error', error)
      }
    )

  }

}
